import { useBase64 } from "../../../../../common/hooks/useBase64";
import useLocationFromCache from "../../../../../common/hooks/useLocationFromCache";
import { formatTimestamp } from "../../../../../common/utils/timestampUtils";
import { errorNotification } from "../../../../../common/variables/notification";
import useCSVDownloader from "../../../../../leak-finder/hooks/useCSVDownloader";
import useConvertArrayToCSV from "../../../../../leak-finder/hooks/useConvertArrayToCSV";
import { useGetGateGuardEventsToExport } from "../gateGuard/hooks/useGetGateGuardEventsToExport";

const useExportAggServerData = () => {
  const { getBase64MediaViewerPageLinkFromS3Key } = useBase64();

  const { downloadCSV } = useCSVDownloader();

  const { convertArrayToCSV } = useConvertArrayToCSV();

  const { getCachedLocation } = useLocationFromCache();

  const { fetchAggTimestreamData, loading } = useGetGateGuardEventsToExport();

  const aggColumns = [
    { field: "licensePlate", headerName: "Plate Number" },
    { field: "driver_name", headerName: "Driver" },
    { field: "company_name", headerName: "Company" },
    { field: "category_name", headerName: "Category" },
    { field: "cameraId", headerName: "Device ID" },
    { field: "location", headerName: "Location" },
    { field: "referenceId", headerName: "Reference ID" },
    { field: "locationTags", headerName: "Location tags" },
    { field: "timestamp", headerName: "Timestamp" },
    { field: "mediaOutput", headerName: "Media" },
  ];

  const exportAggData = async () => {
    try {
      const rows = await fetchAggTimestreamData();

      if (rows.length > 0) {
        const updatedRows = rows.map(row => {
          const newRow = { ...row };
          const cachedLocation = newRow.location.includes("#L#")
            ? getCachedLocation(newRow.location ?? "")
            : null;
          const locationParts = cachedLocation?.name ?? newRow.location;

          if (locationParts.length > 1) {
            newRow.location = locationParts;
          }

          newRow.referenceId = cachedLocation?.referenceId ?? "";

          newRow.locationTags =
            cachedLocation?.tags?.map(t => t.tagName).join(", ") ?? "";

          newRow.timestamp = formatTimestamp(newRow.timestamp);

          if (newRow.mediaOutput) {
            newRow.mediaOutput = getBase64MediaViewerPageLinkFromS3Key(
              newRow.mediaOutput
            );
          }

          return newRow;
        });

        const csvString = convertArrayToCSV(updatedRows, aggColumns);

        downloadCSV(csvString, `agg_events.csv`);
      } else {
        errorNotification("No data available to export");
      }
    } catch (error) {
      errorNotification("Error exporting gate guard data");

      console.error("Error exporting gate guard data:", error);
    }
  };

  return { exportAggData, loading };
};

export default useExportAggServerData;
